import { ImageConfiguration, Segment, Level } from '@ispm-client/modules/segments/interfaces';
import { SegmentSelectionsHandle, SegmentSelectionsInput } from '@ispm-client/modules/segments/interfaces/segments';
import { set, isEmpty, sortBy } from 'lodash';

const DOUBLE_CLICK_MAX_TIME  = 250;
export function handleSegmentSelections(input?: SegmentSelectionsInput): SegmentSelectionsHandle {
  let svg: SVGSVGElement;
  let segments: Segment[];
  let emitterSegment: Segment;
  let changed: (segment: Segment) => void;
  let imageConfig: ImageConfiguration;
  let initLoaded: boolean = false;
  let listernersSet: boolean = false;
  let svgPaths: SVGElement[] = [];
  let lastClickTime: number = 0;
  let segmentKey:string ='';
  let arr:Array<string>=[];

  function query(selector: string, node?: SVGElement): SVGElement[] {
    return <SVGElement[]> Array.from((node || svg).querySelectorAll(selector));
  }

  return {
    reset: newInput => {
      initSelections(newInput);
    }
  };


  function initSelections(input: SegmentSelectionsInput): void {
    svg = <SVGSVGElement> input.svg;
    changed = (input && input.changed) || (() => { });
    emitterSegment = input.emitterSegment;
    imageConfig = input.imageConfig;
    const isViewMode = input.readOnly;
    if (!initLoaded) {
      svgPaths = deriveSVGPaths(input);
      initLoaded = true;
    }
    if (initLoaded && isViewMode === false && input.isEditable !==false && !listernersSet) {
      activateClickListeners(svgPaths);
    }

    updateSegmentSelections(input);
  }

  function deriveSVGPaths(input): SVGElement[] {
    segments = input.segments;
    let paths: SVGElement[] = [];

      segments.forEach(seg => {
      deriveSegmentKey(seg);
      const elements = <SVGElement[]> Array.from(query(`${imageConfig.pathIdentifier}[name="${segmentKey}"]`));
        paths = paths.concat(elements);
        segmentKey="";
        arr=[];
    });
    return paths;
  }

  function activateClickListeners(svgPaths: SVGElement[]) {
    if (!isEmpty(svgPaths)) {
      svgPaths.forEach(path => {
        path.addEventListener('mousedown', mouseDown);
      });
      listernersSet = true;
    }
  }

  function updateSegmentSelections(input: SegmentSelectionsInput) {
     segments = input.segments;
     if (segments) {
       segments.forEach(seg=>{
         segmentKey="";
         arr=[];
         deriveSegmentKey(seg);
         if(imageConfig.iconIdentifier && imageConfig.iconIdentifier != null) {
           query(`${imageConfig.iconIdentifier}[name="${segmentKey}"`).forEach(icon => {

             if (seg.resected) {
               icon.style.display = 'block';
             } else {
               icon.style.display = 'none';
             }

           });
        }
       })

       segments.forEach(seg => {
         segmentKey = "";
         arr = [];
         const level = seg.level;
         svgPaths.filter(path => {
           imageConfig.segmentIdentifier.forEach(element => {
             arr = arr.concat(seg[element]);
             segmentKey = arr.join("-");
             });
             if(path.attributes.getNamedItem('name').value === segmentKey) {
             return path;
           }
           segmentKey = "";
           arr = [];
          }).forEach(path => {
           path.style.fill = !isEmpty(level) ? level.fillColor : imageConfig.defaultFill;
           if (level && level.fillStroke) {
             path.style.stroke = level.fillStroke;
             path.style.strokeDasharray = 'none';
             path.style.strokeWidth = '2';
           }
         });
       });
     }


  }

  function mouseDown(evt: MouseEvent): void {
    evt.stopPropagation();
    if (evt.timeStamp - lastClickTime < DOUBLE_CLICK_MAX_TIME) {
      return;
    }
    lastClickTime = evt.timeStamp;
    clickSelect(evt);
  }

  function clickSelect(evt: MouseEvent) {
    const target = <SVGElement> evt.target;
    const name = target.getAttribute('name');
    segments.forEach(seg => {
      deriveSegmentKey(seg);
      if(segmentKey == name){
        if (seg.disabled) {
          set(emitterSegment, 'disabled', true);
          set(emitterSegment, 'highlight', true);
          set(emitterSegment, 'name', segmentKey);
          changed(emitterSegment);
          return;
        }
        set(emitterSegment, 'name', segmentKey);
        if (seg.active) {
          seg.active = false;
          seg.level = { code: ''};
          seg.annotator = undefined;
          set(emitterSegment, 'active', false);
          target.style.fill = imageConfig.defaultFill;
        }
        else {
          seg.active = true;
          set(emitterSegment, 'active', true);
        }
        changed(emitterSegment);

      }
      segmentKey="";
      arr=[];
    });

  }

  /**
   * This method will be used for deriving the segment key based on the segment identifier array elements, this will be helpful in getting the
   * segment name.
   */
  function deriveSegmentKey(segment){
    imageConfig.segmentIdentifier.forEach(element => {
      arr = arr.concat(segment[element]);
      segmentKey = arr.join("-");
    });
  }

}



